import { render, staticRenderFns } from "./ZaloInbox.vue?vue&type=template&id=ccf94bbe&scoped=true&"
import script from "./ZaloInbox.vue?vue&type=script&lang=js&"
export * from "./ZaloInbox.vue?vue&type=script&lang=js&"
import style0 from "./ZaloInbox.vue?vue&type=style&index=0&id=ccf94bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf94bbe",
  null
  
)

export default component.exports